import { render, staticRenderFns } from "./MixAndMatchWithSectionTraitPreview.vue?vue&type=template&id=2a4725c9&scoped=true&"
import script from "./MixAndMatchWithSectionTraitPreview.vue?vue&type=script&lang=js&"
export * from "./MixAndMatchWithSectionTraitPreview.vue?vue&type=script&lang=js&"
import style0 from "./MixAndMatchWithSectionTraitPreview.vue?vue&type=style&index=0&id=2a4725c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4725c9",
  null
  
)

export default component.exports